/* Normalise position <‑‑> indexes and URL search params */
export const positionToIndexes = (pos, steps, riskCardSteps) => {
    if (!pos) return { majorIndex: 0, sectionIndex: 0, subIndex: 0 };
  
    // legacy alias
    const majorStep = pos.majorStep === 'useCase' ? steps[0].label : pos.majorStep;
  
    const majorIndex   = steps.findIndex(s => s.label === majorStep);
    const sectionIndex =
      pos.section && majorIndex >= 0 ? steps[majorIndex].sections.indexOf(pos.section) : 0;
    const subIndex     = pos.subStep ? riskCardSteps.indexOf(pos.subStep) : 0;
  
    return {
      majorIndex:   majorIndex   >= 0 ? majorIndex   : 0,
      sectionIndex: sectionIndex >= 0 ? sectionIndex : 0,
      subIndex:     subIndex     >= 0 ? subIndex     : 0
    };
  };
  
  export const indexesToPosition = (m, s, r, steps, riskCardSteps) => ({
    majorStep: m === 0 ? 'useCase' : steps[m]?.label,
    section:   steps[m]?.sections[s],
    subStep:   steps[m]?.label === 'modelRisks' ? riskCardSteps[r] : undefined,
    sourceIndex: undefined, // Will be set by RiskFlowWrapperV2
    sourceName: undefined   // Will be set by RiskFlowWrapperV2
  });
  
  /* -------- deep‑link helpers -------- */
  export const positionToSearch = (pos) => {
    const p = new URLSearchParams();
    p.set('step', pos.majorStep);
    if (pos.section) p.set('section', pos.section);
    if (pos.subStep) p.set('sub', pos.subStep);
    if (pos.sourceIndex !== undefined) p.set('sourceIndex', pos.sourceIndex.toString());
    if (pos.sourceName) p.set('sourceName', pos.sourceName);
    return p;
  };
  
  export const searchToPositionObject = (search) => {
    const p = new URLSearchParams(search);
    if (!p.get('step')) return null;
    return {
      majorStep: p.get('step'),
      section:   p.get('section') || undefined,
      subStep:   p.get('sub')     || undefined,
      sourceIndex: p.get('sourceIndex') ? parseInt(p.get('sourceIndex'), 10) : undefined,
      sourceName: p.get('sourceName') || undefined
    };
  };